// Everest list endpoints answer `{ data, paginator: { page, limit, total,
// total_pages } }`; MyDataTable / MyPagination read an Argus-style `meta`.
// Shared adapter between the two.
export default function paginatorToMeta(paginator) {
  const totalPages = Math.max(1, Number(paginator?.total_pages ?? 1) || 1)
  const currentPage = Number(paginator?.page ?? 1) || 1
  return {
    current_page: currentPage,
    per_page: paginator?.limit,
    total: paginator?.total,
    total_page: totalPages,
    prev_page: currentPage > 1 ? currentPage - 1 : null,
    next_page: currentPage < totalPages ? currentPage + 1 : null,
  }
}
